import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface InfoTooltipProps {
  title: string;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ title }) => {
  return (
    <Tooltip title={title} arrow placement="top">
      <IconButton size="small" sx={{ padding: '2px', ml: 0.5, color: 'text.secondary', verticalAlign: 'middle', "&:hover":{color: 'primary.main'} }}>
        <InfoOutlinedIcon fontSize="small" sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Tooltip>
  );
};
